import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import Textarea from 'components/react-validation/components/text-area';
import * as Vali from 'helper/validator-helper';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';

class AddLotNoteModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    ErrorMsg: PropTypes.array,
    editItem: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      resolutionDate: props.editItem ? (props.editItem.resolutionDate ? Moment(props.editItem.resolutionDate).format('MM/DD/YYYY') : '') : '', // eslint-disable-line
      note: props.editItem ? props.editItem.note : '',
      resolution: props.editItem ? props.editItem.resolution : '',
      closed: props.editItem ? props.editItem.closed : false
    };
  }

  onChange = (e, type) => {
    this.setState({
      [type]: e.value
    });
  }

  onChangeResolutionDate = (resolutionDate) => {
    if (typeof (resolutionDate) === 'string') {
      this.setState({ resolutionDate });
      if (Moment(resolutionDate, 'MM/DD/YYYY', true).isValid() || resolutionDate === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    } else {
      this.setState({ resolutionDate: Moment(resolutionDate).format('MM/DD/YYYY') });
      if (Moment(resolutionDate, 'MM/DD/YYYY', true).isValid() || resolutionDate === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    }
  }

  closeModal = () => {
    this.props.onCloseModal();
  }

  onSubmit = (e) => {
    if (e) { e.preventDefault(); }
    const formValues = this.form.getValues();
    const { resolution, note } = formValues;
    const { resolutionDate, closed } = this.state;
    const params = {
      resolution,
      note,
      closed
    };
    if (resolutionDate) {
      params.resolutionDate = Moment.isMoment(resolutionDate) ? formatTimezoneDateTime(resolutionDate) : formatTimezoneDateTime(Moment(resolutionDate));
    }
    if (this.props.editItem) {
      params.id = this.props.editItem.id;
    }
    this.props.onSubmit(params);
  }

  render() {
    const disabled = this.state.dateError;
    let {note, resolution} = this.state;

    if (this.form) {
      resolution = this.form.getValues().resolution;
      note = this.form.getValues().note;
    }
    return (
      <div className=''>
        <Modal show={true}>
          <Form ref={ref => {this.form = ref;}} onSubmit={this.onSubmit}>
            <Modal.Header>
              <Modal.Title id='contained-modal-title-lg'>{this.props.editItem ? 'Edit note' : 'New note'}</Modal.Title>
              <span className='close' onClick={this.closeModal} >&times;</span>
            </Modal.Header>
            <Modal.Body>
              <div className='form-group'>
                <label htmlFor='streetAddress'>Note <span className='text-danger'>*</span></label>
                <Textarea name='note'
                  ref='note'
                  placeholder='Note'
                  className='form-control'
                  max='1000'
                  value={note}
                  maxLength='1000'
                  validations={[Vali.maxlength, Vali.required]} />
              </div>
              <div className='form-group'>
                <label htmlFor='resolutionDate'>Resolution date</label>
                <Datetime
                  ref={ref => { this.resolutionDate = ref; }}
                  inputProps={{ placeholder: 'mm/dd/yyyy' }}
                  timeFormat={false}
                  value={this.state.resolutionDate}
                  onChange={resolutionDate => this.onChangeResolutionDate(resolutionDate)}
                  closeOnSelect={true}  />
                {this.state.dateError &&
                  <span
                    className='text-danger'
                    style={{fontSize: 12, marginTop: 5}}>{this.state.dateError}</span>
                }
              </div>
              <div className='form-group'>
                <label htmlFor='note'>Resolution</label>
                <Textarea name='resolution'
                  ref='resolution'
                  placeholder='Resolution'
                  className='form-control'
                  max='1000'
                  maxLength='1000'
                  value={resolution}
                  validations={[Vali.maxlength]} />
              </div>

              <div className='form-group'>
                <CheckBoxSingle
                  ref={c => { this.checkBox = c; }}
                  style={{display: 'inline-block'}}
                  onChecked={() => this.setState({closed: !this.state.closed})}
                  checked={this.state.closed}
                  label='Closed' />
              </div>
            </Modal.Body>
            <Modal.Footer style={{textAlign: 'left'}} >
              <span className='btn btn-siteone-default' onClick={this.closeModal}>Cancel</span>
              <Submit className='btn btn-primary btn-siteone' disabled={disabled} style={{marginLeft: 10, marginRight: 20}}>{this.props.editItem ? 'Save' : 'Create'}</Submit>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default AddLotNoteModal;




// WEBPACK FOOTER //
// ./src/Lots/Components/AddEditLotNote.js